




















































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";
import roles, { SubRole } from "@/config/wow/roles";

import { getTimeSince } from "@/utils/date-helpers";


/**
 * Components
 */
import SummaryTable from "./components/SummaryTable.vue";
import UsersRepartitionTable from "./components/UsersRepartitionTable.vue";

/**
 * API
 */
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { GetRostersResponse } from "@/api/rosters/get-rosters.response";

/**
 * Mixins
 */
import mixinNow from "@/mixins/now-mixin";


/**
 * Types
 */


/**
 * VueX Modules
 */
const teamModule = namespace("team");


interface RoleList {
	name: string;
	subRole: SubRole | "";
	count: number;
}

/**
 * Roster's dashboard sub page.
 */
@Component({
	components: {
		SummaryTable,
		UsersRepartitionTable
	}
})
export default class DashboardRosterSubPage extends Mixins(mixinNow) {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	roles = roles;
	armorTypes = armorTypes;

	getTimeSince = getTimeSince;

	/// Properties
	@Prop()
	rosters!: GetRostersResponse.Roster[];

	/// Attributes
	isLoading = false;


	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	/**
	 * The current roster to display.
	 */
	get displayedRoster(): GetRostersResponse.Roster | null {
		return this.rosters.find(x => x.id == this.$route.params.rosterId) ?? null;
	}

	get rolesData(): RoleList[] {
		const displayedRoster = this.displayedRoster;
		if (displayedRoster == null) {
			return [];
		}

		const result: RoleList[] = [];
		for (const role of roles) {
			if (role.subroles.length == 0) {
				result.push({
					name: role.name,
					subRole: "",
					count: displayedRoster.characters.filter(x => x.role == role.name).length
				});
			}
			else {
				role.subroles.forEach(function (subRole) {
					if (subRole != "") {
						result.push({
							name: role.name,
							subRole: subRole,
							count: displayedRoster.characters.filter(x => x.role == role.name && x.subRole == subRole).length
						});
					}
				});
			}
		}
		return result;
	}

	/// Methods
	async created() {
		this.isLoading = true;

		//
		// if (this.displayedRoster == null) {
		// 	await this.$router.push("/");
		// }


		this.isLoading = false;

		// this.connection.on("CharacterSync", function (characterUpdated) {
		// 	that.rosters = that.rosters.map((roster) => ({
		// 		...roster,
		// 		characters: roster.characters.map((character) => {
		// 			if (character.id === characterUpdated.id) {
		// 				return characterUpdated;
		// 			}
		// 			else {
		// 				return character;
		// 			}
		// 		})
		// 	}));
		// });
	}
}
